import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from '../../../../services/api/auth/auth.service';
import { LoaderService } from '../../../../services/loader/loader.service';
import { BasePopupComponent } from '../base-popup/base-popup.component';
import { SuccessPopupComponent } from '../success-popup/success-popup.component';

@Component({
    selector: 'app-verify-email-popup',
    standalone: false,
    templateUrl: './verify-email-popup.component.html',
    styleUrl: './verify-email-popup.component.scss',
})
export class VerifyEmailPopupComponent extends BasePopupComponent {
    protected confirmButtonLabel: string = 'Okay';

    constructor(
        @Inject(MAT_DIALOG_DATA) protected override data: string,
        protected override dialogRef: MatDialogRef<VerifyEmailPopupComponent>,
        private authService: AuthService,
        private loaderService: LoaderService,
        private dialog: MatDialog,
    ) {
        super(data, dialogRef);
    }

    protected resendVerifyEmail(): void {
        this.loaderService.show();
        this.authService.resendVerifyEmail(this.data).subscribe({
            next: () => {
                this.dialogRef.close();
                const popupConfig = SuccessPopupComponent.getDialogConfig();
                popupConfig.data = {
                    title: 'Check your inbox!',
                    message: `We’ve sent a fresh verification link to <strong>${this.data}</strong>`,
                };
                this.dialog.open(SuccessPopupComponent, popupConfig);
            },
            error: (error) => {
                const errorPopupConfig = SuccessPopupComponent.getDialogConfig();
                errorPopupConfig.data = {
                    title: `Error`,
                    message: error.error?.message,
                };
                this.dialog.open(SuccessPopupComponent, errorPopupConfig);
                console.error('Error on resending verfication email', error);
            },
            complete: () => {
                this.loaderService.hide();
            },
        });
    }
}
